import React, { useState } from 'react';
import styled from 'styled-components';

import COLORS from 'constants/colors';
import ConfirmationOverlay from 'shared/ConfirmationOverlay';
import Icon from 'components/elements/Icon';

export interface FailedAnalysisWarningOverlayProps {
  identifier: string;
  lead: string;
  onConfirmClick: (event: React.MouseEvent) => void;
  onCancelClick: (event: React.MouseEvent) => void;
}

const CONSEQUENCES = ['consequence_rejected', 'consequence_blocked'];

const Lead = styled.p`
  margin-bottom: 1rem;
  font-weight: bold;
`;

const Consequences = styled.ul`
  margin: 0 0 1rem;
  border-left: 4px solid ${COLORS.RED};
  padding: 0.75rem 1rem;
  background: rgba(177, 42, 49, 0.08);
  list-style: none;

  li {
    align-items: flex-start;
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const Advice = styled.p`
  margin-bottom: 1rem;
`;

const Acknowledge = styled.label`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  cursor: pointer;
  font-weight: bold;
`;

function FailedAnalysisWarningOverlay({
  identifier,
  lead,
  onConfirmClick,
  onCancelClick,
}: FailedAnalysisWarningOverlayProps) {
  const [acknowledged, setAcknowledged] = useState(false);

  return (
    <ConfirmationOverlay
      id={`${identifier}_failed_analysis_warning`}
      title={I18n.translate('failed_analysis_warning.title')}
      titlePrefix={identifier}
      confirmText={I18n.translate('failed_analysis_warning.confirm')}
      cancelText={I18n.translate('buttons.cancel')}
      onConfirmClick={onConfirmClick}
      onCancelClick={onCancelClick}
      primaryClassName='button button--red'
      primaryDisabled={!acknowledged}
    >
      <Lead>{lead}</Lead>

      <Consequences>
        {CONSEQUENCES.map((key) => (
          <li key={key}>
            <Icon icon='cross' color={COLORS.RED} />

            {I18n.translate(`failed_analysis_warning.${key}`)}
          </li>
        ))}
      </Consequences>

      <Advice>{I18n.translate('failed_analysis_warning.advice')}</Advice>

      <Acknowledge>
        <input
          type='checkbox'
          checked={acknowledged}
          onChange={(event) => setAcknowledged(event.target.checked)}
        />

        {I18n.translate('failed_analysis_warning.acknowledge')}
      </Acknowledge>
    </ConfirmationOverlay>
  );
}

export default FailedAnalysisWarningOverlay;
